import { CircularProgress } from "@material-ui/core";
import PDFViewer from "mgr-pdf-viewer-react";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
    ToastsContainer,
    ToastsContainerPosition,
    ToastsStore,
} from "react-toasts";
import { setTimeout } from "timers";
import { API_ENDPOINT, callApi } from "../../utils/api";
import { ADMIN_ROLE, FRONTOFFICE_ROLE, MANAGER_ROLE } from "../../utils/role";
import ReactFileReader from "react-file-reader";
import { saveAs } from "file-saver";
import { notifyToUser } from "../../utils/firebase";
import moment from "moment";
import { pushnotificationApi } from "../../utils/pushNotify";
import Spinner from "../PDF-Highlighter/Spinner";
import Accordion from "react-bootstrap/Accordion";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import "bootstrap/dist/css/bootstrap.css";
import { compressPdf } from "../PdfCompress/PdfCompressor";
import Select from 'react-select';

declare var $: any;
interface AllProps {
    id: any;
    isFinal: boolean;
    checkOverviewApproval: any;
    history: any;
    fileId: any;
    fileName: any
    location: any;
}
interface AllProps {
    match: any;
    history: any;
}
export default class SignatureFile extends Component<AllProps> {
    state = {
        showTitle: true,
        isComplete: true,
        isLoading: false,
        report: "",
        signreport: "",
        rep_id: "",
        remote_users: [],
        isapproved: 0,
        office_users: [],
        responseURL: "",
        pdfPreview: "",
        realFileidfk: "",
        file: "",
        pdfurl: "",
        enableRefresh: true,
        isApprove: false,
        isVerify: false,
        action: "",
        reason: "",
        uploadFile: {
            base64: "",
            fileList: [{ name: "" }],
            originalSize: '',
            compressedSize: '',
        },
        updateDownloadData: {
            reasonForDownload: [],
            updatedDetails: [],
        },
        lastUploadedDocument: {
            pdf: '',
            docx: '',
        },
        timer: 0,
        blockdownload: "",
        activetab: "wordkey",
        isDownloaded: false,
        isUploaded: false,
        // isPdfCompress: 'off',
        // isGlobalPdfCompress: '',
        // globalPdfCompressQuality: '',
        // isFrontOfficePdfCompressShow: '',
        previewPdf: '',
        isbtnload: false,
        bankWithLawhadnsBranch: [],
        bank_private_name_id: '',
        product_id: '',
        lawhands_branch_id: '',
    };
    rendered: any;
    componentDidMount() {
        this.getUpdateReasonData();
        this.getFilesDetails();
        this.getBankWithLawhandsBranch();
        // this.fetchPdfSettings();
    }

    getBankWithLawhandsBranch() {
        callApi("GET", "bank_branch_get_management.php")
            .then((res) => res.data)
            .then((result) => {
                this.setState({ bankWithLawhadnsBranch: result.data });
            })
            .catch((err) => {
                console.log(err);
            });
    }
    getFilesDetails = () => {
         const isLegal = this.props.location?.state?.hash == 'Legal';

        callApi("POST", "search.php", {
                [isLegal ? "file_name" : "vetting_file_name"]: this.props.match.params.id,
                "search_type": isLegal ? "file_name" : "vetting"
            }
        )
            .then(res => res.data)
            .then(response => {
                if (response['data'] && response['data'][0]) {
                    const bank_private_name_id = response['data'][0].bank_private_name_id;
                    const product_id = response['data'][0].bank_product;
                    const lawhands_branch_id = response['data'][0].lawhands_branch_id;
                    this.setState({ bank_private_name_id, product_id, lawhands_branch_id });
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    // fetchPdfSettings = () => {
    //     callApi("POST", "pdf_category.php")
    //         .then((res) => res.data)
    //         .then((response: any) => {
    //             if (response.result && response.data) {
    //                 const isGlobalPdfCompress = response.data['Pdf document']?.find((item: any) => item.name == 'Pdf Compression While Uploading Document')?.status == '1';
    //                 const globalPdfCompressQuality = response.data['Pdf document']?.find((item: any) => item.name == 'Pdf Compression While Uploading Document')?.quality;
    //                 const isFrontOfficePdfCompressShow = response.data['Pdf document']?.find((item: any) => item.name == 'In Signature Show/Hide')?.status == '1';
    //                 this.setState({
    //                     isGlobalPdfCompress,
    //                     isFrontOfficePdfCompressShow,
    //                     globalPdfCompressQuality,
    //                 });
    //             }
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //             ToastsStore.error("Failed to load PDF settings");
    //         });
    // };

    incrementTimer = () => {
        const { timer } = this.state;
        this.setState({ timer: timer + 1 });
    };

    signatureReport = () => {
        const isLegal = this.props.location?.state?.hash == 'Legal';
        const api = isLegal ? "sign_upload_pdf.php" : "vetting_sign_upload_pdf.php";
        callApi("POST", api, { id: this.props.match.params.id })
            .then((res) => res.data)
            .then((response) => {
                if (response && response?.responseJson?.data) {
                    this.setState({ signreport: response?.responseJson?.data[0]?.filepath, enableRefresh: true });
                }
            });
    };

    handleTabSelect = (tabKey: any) => {
        this.setState({ activekey: tabKey }, () => {
            if (tabKey === 'wordkey') {
                this.getUpdateReasonData();
            } else if (tabKey === 'pdfkey') {
                this.signatureReport();
            }
        })
    }

    delaylaoding = (realFileidfk) => {
        setTimeout(() => {
            console.log(realFileidfk);
            this.setState({
                realFileidfk,
            });
        }, 10000);
    };
    downloadPDF = () => {
        const input: any = document.getElementById("report-content");
        let mywindow: any = window.open(
            "",
            "PRINT",
            "height=650,width=900,top=100,left=150"
        );
        mywindow.document.write(input.innerHTML);
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        mywindow.print();
        mywindow.close();

        ToastsStore.success("Downloaded Successfully!");
        return true;
    };

    getUpdateReasonData = () => {
        const reasonData: any = this.state.updateDownloadData;
        const isLegal = this.props.location?.state?.hash == 'Legal' || this.props.location?.state?.hash == 'Legal';
        const api = isLegal ? "dashboard_log.php" : "vetting_dashboard_log.php";
        callApi("POST", api, { id: this.props.match.params.id })
            .then((res) => res.data)
            .then((result) => {
                let { lastUploadedDocument } = this.state;
                reasonData.reasonForDownload = result.data.reasonForDownload;
                // Object.keys(result.data[0][1]).map(key => result.data[0][1][key]);
                reasonData.updatedDetails = result.data.updatedDetails;
                if (reasonData.updatedDetails && reasonData.updatedDetails.length > 0) {
                    lastUploadedDocument = reasonData.updatedDetails[0].url[0];
                }
                // result.data[0][0];
                console.log("reasonData", reasonData);
                this.setState({ updateDownloadData: reasonData, lastUploadedDocument });
            })
            .catch((err) => {
                console.log("Errororor", err);
                // ToastsStore.error("Failed to get ");
            });
    };

    //Download docs from external api
    downloadDocs = () => {
        const { lastUploadedDocument } = this.state;
        const isLegal = this.props.location?.state?.hash == 'Legal';
        const api = isLegal ? "shell" : "shell_vetting";
        if (lastUploadedDocument.pdf) {
            const api = isLegal ? "get_branch_code.php" : "vetting_get_branch_code.php";
            callApi("POST", api, {
                id: this.props.match.params.id,
            })
                .then((res) => res.data)
                .then((response) => {
                    console.log(response);
                    // const name = `${response.data[0].lawhands_branch}-${this.props.match.params.id}.docx`;
                    const name = `${response.data[0].lawhands_branch}-${this.props.match.params.id}.pdf`;
                    // lastUploadedDocument.docx && saveAs(lastUploadedDocument.docx, name);
                    lastUploadedDocument.pdf && saveAs(lastUploadedDocument.pdf, name);
                });
        } else {


            callApi("POST", `template/tests/${api}.php?id=${this.props.match.params.id}`, {
                id: this.props.match.params.id,
                responseType: "blob",
            })
                .then((res) => res.data)
                .then((response) => {
                    //ToastsStore.success("Downloaded Successfully!");
                    window.open(
                        API_ENDPOINT + `template/tests/${api}.php?id=` + this.props.match.params.id,
                        "_blank"
                    );
                });
        }
        // ToastsStore.success("Downloaded Successful!");
    };
    actionHandle = (action) => {
        this.setState({ action });
    };
    handleReasonChange = (e) => {
        this.setState({ reason: e.target.value });
    };
    validateReason = () => {
        if (this.state.reason === "") {
            ToastsStore.error("Please Enter Reason");
        } else {
            if (this.state.action === "download") {
                this.downloadDoc();
            } else {
                this.uploadHandler();
            }
        }
    };
    downloadDoc = () => {
        this.setState({ isLoading: true });
        $("#reason-modal").modal("hide");
        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        const obj = {
            fileid: this.props.match.params.id,
            reason: this.state.reason,
            createdBy: userId,
            isSign: 1, // 1 for signature file
        };
        const isLegal = this.props.location?.state?.hash == 'Legal';
        const api = isLegal ? "download_log.php" : "vetting_download_log.php";
        callApi("POST", api, obj)
            .then((res) => res)
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    // ToastsStore.success("work file Q & A are saved succesfully")
                    ToastsStore.success("Reason saved successfully");
                    this.downloadDocs();
                    this.clearModal();
                    this.setState({ isDownloaded: true, isLoading: false });
                } else {
                    ToastsStore.error("Error in storing, Please try again!");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    uploadFile = async (file: any) => {
        // const { isGlobalPdfCompress, globalPdfCompressQuality, isPdfCompress } = this.state;
        // this.setState({ isbtnload: true });
        // if (isGlobalPdfCompress && isPdfCompress == "on") {

        //     const quality: any = globalPdfCompressQuality;

        //     const { compressedBase64, originalSize, compressedSize } = await compressPdf({
        //         base64: file.base64,
        //         quality,
        //     });

        //     this.setState({
        //         previewPdf: compressedBase64,
        //         uploadFile: {
        //             ...file,
        //             base64: compressedBase64,
        //             originalSize,
        //             compressedSize,
        //             fileList: file.fileList || [{ name: file.name || "" }],
        //         }
        //     });
        //     this.setState({ isbtnload: false });
        // } else {
        this.setState({
            previewPdf: file.base64,
            uploadFile: file,
        });
        this.setState({ isbtnload: false });
        // }
    };

    uploadHandler = () => {
        this.setState({ isLoading: true });
        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        const obj = {
            fileid: this.props.match.params.id,
            reason: this.state.reason,
            createdBy: userId,
            file: this.state.uploadFile.base64,
            errorTypes: ["1", "2"],
            errorSection: ["1", "2"],
        };
        const isLegal = this.props.location?.state?.hash == 'Legal';
        const api = isLegal ? "sign_upload_log.php" : "vetting_sign_upload_log.php";
        callApi("POST", api, obj)
            .then((res) => res)
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    this.setState({ isUploaded: true });
                    $("#reason-modal").modal("hide");
                    this.getUpdateReasonData();
                    this.setState({ isComplete: false, isLoading: false });
                    this.setState({ activetab: "pdfkey" });
                    // ToastsStore.success("work file Q & A are saved succesfully")
                    ToastsStore.success("Reason saved successfully");
                    this.clearModal();
                    // this.signatureReport();
                    console.log("activetab", this.state.activetab);
                } else {
                    ToastsStore.error("Error in storing, Please try again!");
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ isComplete: false, isLoading: false });
                ToastsStore.error("Please try again!");
            });
    }
    clearModal = () => {
        this.setState({
            reason: "",
        });
    };
    enableModalHandler = () => {
        $("#complete-process").modal("show");
    };
    close = () => {
        $("#processComplete").modal('hide');
        this.previousPage();
        // this.props.history.push("/inprogress-file");
    }

    completeFlowHandler = () => {
        this.setState({ showTitle: true, isLoading: true })
        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        const report_to = user ? JSON.parse(user)["report_to"] : "";
        // file status 6 => moved to "files to be verfied"
        const isLegal = this.props.location?.state?.hash == 'Legal';
        const api = isLegal ? "file_status.php" : "bill_vetting_complete.php";
        callApi("POST", api, {
            id: this.props.match.params.id,
            file_id: this.props.match.params.id,
            userID: userId,
            status: isLegal ? 11 : 3, // 11 for legal, 3 for vetting
            file_status: isLegal ? 11 : 3, // 11 for legal, 3 for vetting
        })
            .then((res) => res)
            .then((response) => {
                console.log(response);
                this.setState({ showTitle: false, isLoading: false })
                if (response.status === 200) {
                    if (isLegal) {
                        this.signverificationtime("complete");
                    }

                    const filterBankLHBranch: any = this.state.bankWithLawhadnsBranch.find(
                        (bank: any) =>
                            bank?.bank_id == this.state?.bank_private_name_id &&
                            bank?.product_id == this.state?.product_id &&
                            bank?.lawhands_branch == this.state?.lawhands_branch_id
                    );

                    const isAutoMail = filterBankLHBranch?.autoMail === '1';
                    const isMailpdf = filterBankLHBranch?.pdf === '1';
                    const isMaildoc = filterBankLHBranch?.doc === '1';
                    const is_vetting_AutoMail = filterBankLHBranch?.vetting_autoMail === '1';
                    const is_vetting_Maildoc = filterBankLHBranch?.vetting_doc === '1';
                    const is_vetting_Mailpdf = filterBankLHBranch?.vetting_pdf === '1';

                    const isReportSendMail = isAutoMail && (isMailpdf || isMaildoc);

                    const isvettingReportSendMail = is_vetting_AutoMail && (is_vetting_Mailpdf || is_vetting_Maildoc);

                    if ((isLegal && isReportSendMail) || (!isLegal && isvettingReportSendMail)) {
                        const payload = {
                            file_id: this.props.match.params.id,
                            send_pdf: isLegal ? isMailpdf : is_vetting_Mailpdf,
                            send_word: isLegal ? isMaildoc : is_vetting_Maildoc,
                            "file_status": isLegal ? "Legal Signature Auto Trigger" : "Vetting Signature Auto Trigger",
                            "created_by": userId
                        };

                        this.sendUploadPayload(payload, isLegal);
                    }

                    $("#processComplete").modal('show');
                    // const user: any = localStorage.getItem("user");
                    // const userId = user ? JSON.parse(user)["userId"] : "";
                    const userName = user ? JSON.parse(user)["firstName"] : "";
                    const notifyData = {
                        title: `${this.props.match.params.id}Typing Completed By ${userName}`, notifyType: "message", updatedAt: moment().format("YYYY-MM-DD HH:mm:ss")
                    };
                    pushnotificationApi(notifyData, userId);
                    const branchManger: any = localStorage.getItem("branch_manager");
                    const branch_Manager = JSON.parse(branchManger);
                    const queryOfficer: any = localStorage.getItem("Query_officer");
                    const query_ooficer = JSON.parse(queryOfficer);
                    const Scan_officer: any = localStorage.getItem("scan_officer");
                    const sacanofficer = JSON.parse(Scan_officer);
                    const process_mennager: any = localStorage.getItem("process_manager");
                    const processManager = JSON.parse(process_mennager);
                    if (Array.isArray(branch_Manager) && branch_Manager.length > 0) {
                        notifyToUser("user", { ...notifyData, notifyType: "message" }, branch_Manager);
                        const branchManager = branch_Manager.join(",");
                        let obj = {
                            notification_type: "typingcomplete",
                            user_id: branchManager,
                            ...notifyData,
                            reason: `${this.props.match.params.id}Typing Completed`
                        }
                        callApi("POST", "pushnotification.php", obj)
                            .then((res) => res.data)
                            .then((response) => {
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                    if (Array.isArray(query_ooficer) && query_ooficer.length > 0) {
                        notifyToUser("user", { ...notifyData, notifyType: "notify" }, query_ooficer);
                        const OfficerQuery = query_ooficer.join(",");
                        let obj = {
                            notification_type: "typingcomplete",
                            user_id: OfficerQuery,
                            ...notifyData,
                            reason: `${this.props.match.params.id}Typing Completed`
                        }
                        callApi("POST", "pushnotification.php", obj)
                            .then((res) => res.data)
                            .then((response) => {
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                    // if (Array.isArray(sacanofficer) && sacanofficer.length > 0) {
                    //   notifyToUser("user", { ...notifyData, notifyType: "message" }, sacanofficer);
                    // }
                    if (Array.isArray(processManager) && processManager.length > 0) {
                        notifyToUser("user", { ...notifyData, notifyType: "message" }, processManager);
                        const ProcessManager = processManager.join(",");
                        let obj = {
                            notification_type: "typingcomplete",
                            user_id: ProcessManager,
                            ...notifyData,
                            reason: `${this.props.match.params.id}Typing Completed`
                        }
                        callApi("POST", "pushnotification.php", obj)
                            .then((res) => res.data)
                            .then((response) => {
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                } else {
                    ToastsStore.error("Error in completing the file , Please try again!");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    sendUploadPayload = async (payload: any, isLegal) => {
        const api = isLegal ? 'auto_mail_report_send.php' : 'vetting_auto_mail_report_send.php';
        callApi("POST", api, payload)
            .then(res => res.data)
            .then(response => { }).catch(err => { });
    };

    signverificationtime(type) {
        const props: any = this.props;
        const loginuser: any = localStorage.getItem("user1");
        const reason = "Signature Completed";
        const obj = {
            id: props.match.params.id,
            reason: reason,
            created_by: JSON.parse(loginuser),
            color: "#aceaaf",
        };
        callApi("POST", "time_update.php", obj)
            .then(res => res.data)
            .then(response => { });
    }

    previousPage = () => {
        const fileurl: any = localStorage.getItem("url");
        $("#in_time").modal("hide");
        localStorage.removeItem("currentfileId")
        localStorage.removeItem("thisPopup");
        this.props.history.push(`${fileurl}`);
        localStorage.removeItem("url");
    }
    render() {
        const user: any = localStorage.getItem("user");
        const role_id = user ? JSON.parse(user)["role_id"] : "";
        const {
            action,
            reason,
            uploadFile,
            lastUploadedDocument,
            timer,
            isComplete,
            showTitle,
            isDownloaded,
            isUploaded
        } = this.state;
        const isTakenFile = this.props.location?.state?.takeFile;

        // let pdfCompressDropdown = [
        //     { value: "on", label: "On" },
        //     { value: "off", label: "Off" },
        // ];

        return (
            <section className="pcoded-main-container">
                <ToastsContainer
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_RIGHT}
                />
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <div className="d-fles">
                                                        <h5 style={{ fontSize: "20px " }}>Signature File</h5>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline"

                                                            onClick={() => this.previousPage()}
                                                            style={{ width: '76px', fontSize: '17px', border: '1px solid black', float: "right" }}
                                                        > Back</button>
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <Accordion className="mainAccordion">
                                                        <Tabs
                                                            defaultActiveKey={this.state.activetab}
                                                            style={{ padding: 0 }}
                                                            onSelect={(name) => {
                                                                this.setState({ activeMainTab: name });
                                                                this.handleTabSelect(name);
                                                            }}
                                                        >
                                                            <Tab eventKey="wordkey" title="PDF Overview">
                                                                <div className="">
                                                                    {isTakenFile &&
                                                                        <div className="buttons" style={{ margin: "2%" }}>
                                                                            <button
                                                                                className="btn btn-outline-dark"
                                                                                onClick={() => this.actionHandle("download")}
                                                                                data-toggle="modal"
                                                                                data-target="#reason-modal"
                                                                                style={{ fontWeight: "bold", borderWidth: "2px" }}
                                                                            >
                                                                                Download Doc <i className="fa fa-download" />
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-outline-dark"
                                                                                onClick={() => this.actionHandle("upload")}
                                                                                disabled={!isDownloaded}
                                                                                data-toggle="modal"
                                                                                data-target="#reason-modal"
                                                                                style={{ fontWeight: "bold", borderWidth: "2px" }}
                                                                            >
                                                                                Upload Doc <i className="fa fa-upload" />
                                                                            </button>
                                                                            {/* <button type="button" className="btn btn-primary"
                                                                            style={{ marginTop: '0px' }}>Complete
                                                                        </button> */}
                                                                            {isComplete && (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary"
                                                                                    style={{ marginTop: "0px", float: "right" }}
                                                                                    onClick={this.enableModalHandler}
                                                                                    disabled={this.state.isLoading || !isDownloaded || !isUploaded}
                                                                                >
                                                                                    {this.state.isLoading ? (
                                                                                        <i className="fa fa-spinner fa-spin"></i>
                                                                                    ) : "Complete"}
                                                                                </button>
                                                                            )}

                                                                            {!isComplete && (
                                                                                <>
                                                                                    <button
                                                                                        onClick={() => this.completeFlowHandler()}
                                                                                        type="button"
                                                                                        className="btn btn-primary"
                                                                                        style={{ marginTop: "0px", float: "right" }}
                                                                                        disabled={this.state.isLoading}
                                                                                    >
                                                                                        {this.state.isLoading ? (
                                                                                            <i className="fa fa-spinner fa-spin"></i>
                                                                                        ) : "Complete"}
                                                                                    </button>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    }
                                                                    <div style={{ marginTop: "10px" }} />
                                                                    {/* {this.state.report ? ( */}
                                                                    {lastUploadedDocument?.pdf != '' ? (
                                                                        <iframe
                                                                            width="100%"
                                                                            height="600"
                                                                            frameBorder="0"
                                                                            src={`${lastUploadedDocument?.pdf}#toolbar=0`}
                                                                        ></iframe>
                                                                    ) : (
                                                                        <div className="text-center">
                                                                            <span>PDF not found</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Tab>
                                                            <Tab eventKey="pdfkey" title="Pdf with Signature">
                                                                <div>
                                                                    <div style={{ marginTop: "10px" }} />
                                                                    {this.state.signreport ? (
                                                                        <iframe
                                                                            width="100%"
                                                                            height="600"
                                                                            frameBorder="0"
                                                                            // src={this.state.signreport}
                                                                            src={`${this.state.signreport}#toolbar=0`}

                                                                        ></iframe>
                                                                    ) : (
                                                                        <div className="text-center">
                                                                            <span>PDF not found.</span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Tab>
                                                        </Tabs>
                                                    </Accordion>

                                                    <div className="modal" id="reason-modal">
                                                        <div className="modal-dialog " style={{ maxWidth: "1000px", maxHeight: "90vh", overflow: "scroll" }}>
                                                            <div className="modal-content">
                                                                <div className="modal-header">
                                                                    {action === "download" ? (
                                                                        <h5 className="modal-title">Reason For Download</h5>
                                                                    ) : (
                                                                        <h5 className="modal-title">Reason For Upload</h5>
                                                                    )}
                                                                    <button type="button" className="close" data-dismiss="modal">
                                                                        &times;
                                                                    </button>
                                                                </div>
                                                                <div className="modal-body">
                                                                    <div>
                                                                        {action === "download" ? (
                                                                            <label>Enter Reason*</label>
                                                                        ) : (
                                                                            <React.Fragment>
                                                                                {/* <div className="form-group">
                                                                                    <label>PDF Compress</label>
                                                                                    <Select
                                                                                        options={pdfCompressDropdown}
                                                                                        name="isPdfCompress"
                                                                                        value={pdfCompressDropdown.find(o => o.value === this.state.isPdfCompress)} // this is correct
                                                                                        onChange={e => this.setState({ isPdfCompress: e.value })}
                                                                                        placeholder="example: Select Option"
                                                                                    />
                                                                                </div> */}

                                                                                <label>Enter Updated Informations*</label>
                                                                                <ReactFileReader
                                                                                    // fileTypes={[".doc", ".docx"]}
                                                                                    fileTypes={[".pdf"]}
                                                                                    base64={true}
                                                                                    // multipleFiles={true}
                                                                                    handleFiles={(e) => this.uploadFile(e)}
                                                                                >
                                                                                    <button
                                                                                        className="ml2 btn btn-success btnupload"
                                                                                    // disabled={this.state.isFlowChartUploading}
                                                                                    >
                                                                                        {/* {this.state.isFlowChartUploading ? (
                                                                                            <i className="fa fa-spinner fa-spin"></i>
                                                                                        ) : <i className="icon feather icon-upload" />} */}
                                                                                        Select File
                                                                                    </button>
                                                                                </ReactFileReader>
                                                                                <span>{uploadFile.fileList[0].name}</span>
                                                                                {this.state.isbtnload && (
                                                                                    <i className="fa fa-spinner fa-spin"></i>
                                                                                )}
                                                                                {this.state.previewPdf && (
                                                                                    <div style={{ marginTop: "15px" }}>
                                                                                        <h6>Preview:</h6>
                                                                                        {/* {(this.state.uploadFile?.originalSize != "" && this.state.uploadFile?.originalSize != undefined) &&
                                                                                            <p className="card-text">
                                                                                                {(this.state.isPdfCompress == "on" && this.state.isGlobalPdfCompress) ? `Original Size: ${(this.state.uploadFile?.originalSize)}, Compressed Size: ${(this.state.uploadFile?.compressedSize)}` : `File Size: ${(this.state.uploadFile?.originalSize)}`}
                                                                                            </p>
                                                                                        } */}
                                                                                        <iframe
                                                                                            src={this.state.previewPdf || this.state.uploadFile.base64}
                                                                                            width="100%"
                                                                                            height="400px"
                                                                                            style={{ border: "1px solid #ccc", borderRadius: "4px" }}
                                                                                            title="PDF Preview"
                                                                                        />
                                                                                    </div>
                                                                                )}

                                                                            </React.Fragment>
                                                                        )}
                                                                        <textarea
                                                                            className="form-control mt-10"
                                                                            name="reason"
                                                                            value={reason}
                                                                            onChange={this.handleReasonChange}
                                                                        ></textarea>
                                                                    </div>
                                                                </div>
                                                                <div className="modal-footer">
                                                                    <button type="button" className="btn " data-dismiss="modal">
                                                                        Cancel
                                                                    </button>
                                                                    {action === "download" ? (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary"
                                                                            onClick={this.validateReason}
                                                                        >
                                                                            Download
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary"
                                                                            onClick={this.validateReason}
                                                                            disabled={this.state.isLoading}
                                                                        >
                                                                            {this.state.isLoading ? (
                                                                                <i className="fa fa-spinner fa-spin"></i>
                                                                            ) : "Upload"}
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="modal hide fade in" id="processComplete" data-backdrop="static" data-keyboard="false">
                                                        <div className="modal-dialog ">
                                                            <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                                                                <div className="modal-body">
                                                                    <h5 style={{ textAlign: 'center' }}> Thanks For Complete Your File:{this.props.match.params.id}</h5>
                                                                </div>
                                                                <div className="modal-footer">
                                                                    {showTitle ? null : (<button
                                                                        type="button"
                                                                        className="btn btn-success"
                                                                        onClick={() => this.close()}
                                                                        // onClick={this.disableModalHandler}
                                                                        style={{ width: '50%', fontSize: '17px', margin: 'auto' }}
                                                                    > Ok</button>)}

                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* This is for modal */}
                                                    <div className="modal" id="complete-process">
                                                        <div className="modal-dialog ">
                                                            <div className="modal-content">
                                                                <div className="modal-body">
                                                                    <h3>Without upload document you can't complete the file</h3>
                                                                </div>
                                                                <div className="modal-footer">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary"
                                                                        data-dismiss="modal"
                                                                    // onClick={this.disableModalHandler}
                                                                    >
                                                                        {" "}
                                                                        Ok
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
